<template>
  <div class="am-g am-margin-bottom-sm">
    <Card :headerStyle="{background: '#d4d5d5'}" dis-hover>
      <h2 slot="title">更多信息</h2>
      <div class="form" v-if="store.storeId">
        <!--业务时间选择-->
        <div class="form-item">
          <div class="form-item-label">
            <span v-if="sendType === 2">自取时间:</span>
            <span v-else>送餐时间：</span>
          </div>
          <div class="form-item-content">
            <template v-if="isAmend">
              {{oldOrderData.sendTime}}
            </template>
            <RadioGroup v-model="orderType" @on-change="changeOrderType" v-else>
              <template v-if="sendType === 1 || sendType === 4">
                <Radio :label="1" v-if="businessType[1]">
                  <span>尽快送达</span>
                </Radio>
                <Radio :label="4" v-if="businessType[4]">
                  <div class="am-inline-block">
                    <div class="am-inline-block am-margin-left-sm">
                      <cc-select :options="storeDateList" v-model="storeDateValue" placeholder="请选择日期"
                                 class="am-text-middle" @change="handleCheckDate"></cc-select>
                    </div>
                    <div class="am-inline-block am-margin-left-sm">
                      <cc-select :options="storeTimeList" v-model="storeTimeValue" placeholder="请选择时间"
                                 class="am-text-middle" @change="handleCheckTime"></cc-select>
                    </div>
                  </div>
                </Radio>
              </template>
              <template v-else>
                <Radio :label="2" v-if="businessType[2]">
                  <div class="am-inline-block">
                    <div class="am-inline-block am-margin-left-sm">
                      <cc-select :options="storeDateList" v-model="storeDateValue" placeholder="请选择日期"
                                 class="am-text-middle" @change="handleCheckDate"></cc-select>
                    </div>
                    <div class="am-inline-block am-margin-left-sm">
                      <cc-select :options="storeTimeList" v-model="storeTimeValue" placeholder="请选择时间"
                                 class="am-text-middle" @change="handleCheckTime"></cc-select>
                    </div>
                  </div>
                </Radio>
              </template>
            </RadioGroup>
          </div>
        </div>
        <!--支付类型-->
        <div class="form-item">
          <div class="form-item-label">支付方式：</div>
          <template v-if="!isAmend">
            <div class="form-item-content">
              <cc-select :options="payOptions" v-model="payType" placeholder="请选择支付类型" :width="130" @change="payChange"
                         :disabled="isAmend"></cc-select>
            </div>
            <div class="form-item-content am-padding-left-sm" v-show="!isSaveOfflinePays || payType !== 1">
                <cc-select :options="payChildOptions" v-model="payChildType" placeholder="请选择支付子类型"
                           @change="payChildChange"
                           :width="130"></cc-select>
            </div>
            <div class="form-item-content am-padding-left-sm" v-show="payType === 1">
              <Button @click.native="showOfflinePayModal" >补充更多支付方式</Button>
            </div>
          </template>
          <template v-else>
            <div class="form-item-content">
              <template v-if="isOnlinePay">
                在线支付
              </template>
              <template v-else>
                <div class="am-flex">
                  <span>线下支付</span>
                  <div v-for="item in orderOfflinePayTypeOptions" :key="item.value" class="am-padding-left-sm"
                       v-if="!item.disabled">
                    <span>{{item.label}}</span>
                    <span class="prefix-price-unit">{{currency}}{{item.money}}</span>
                  </div>
                  <Button class="am-margin-left-sm" @click.native="showOrderAmendPayModal">修改支付方式</Button>
                </div>
              </template>
            </div>
          </template>
        </div>
        <!--发票-->
        <div class="form-item" v-if="store.invoiceType.length>0 || isAmend">
          <div class="form-item-label">发票：</div>
          <div class="form-item-content">
            <div class="order-amend-hint" v-if="isAmend">
              <span v-if="oldOrderData.isInvoice&&oldOrderData.invoiceType!==0">
                <span>需要</span>
                <span v-if="oldOrderData.invoiceType === 1" class="am-padding-left-xs">定额发票</span>
                <span v-else>
                  <span class="am-padding-left-xs">机打发票</span>
                  <span class="am-padding-left-xs">发票抬头{{oldOrderData.invoiceDesc}}</span>
                  <span class="am-padding-left-xs">税号{{oldOrderData.taxNo}}</span>
                </span>
              </span>
              <span v-else>
                <span>不需要发票/<span class="am-padding-left-xs">定额发票 机打发票</span></span>
              </span>
            </div>
            <RadioGroup v-model="invoiceType">
              <Radio :label="0">不需要</Radio>
              <Radio :label="item" v-for="(item, index) in store.invoiceType" :key="index" style="display: block">
                <template slot-scope="{ currentValue }">
                  <template v-if="item === 1">
                    <span>定额发票</span>
                  </template>
                  <template v-else-if="item === 2">
                    <div class="form-item-content" style="display: inline-block">
                      <span class="form-item-content ">机打发票</span>
                      <div class="form-item-content am-padding-left-sm"><Input placeholder="发票抬头"
                                                                               :disabled="!currentValue"
                                                                               v-model="invoiceDesc"/></div>
                      <div class="form-item-content am-padding-left-sm"><Input placeholder="税号"
                                                                               :disabled="!currentValue"
                                                                               v-model="taxNo"/></div>
                      <span class="form-item-content"></span>
                    </div>
                  </template>
                  <template v-else>
                    电子发票
                  </template>
                </template>
              </Radio>
            </RadioGroup>
          </div>
        </div>
        <!--用户喜好-->
        <div class="form-item" v-if="!isAmend">
          <div class="form-item-label">用户喜好：</div>
          <div class="form-item-content">
            <Input v-model="taste" @on-blur="updateTaste(taste)" clearable/>
          </div>
          <div class="form-item-content am-padding-left-sm">
            <Button @click.native="userNote=taste+ ';'">添加到订单备注</Button>
          </div>
        </div>
        <!--杯听-->
        <div class="form-item" v-if="isColaCupConversionListeningSet">
          <div class="form-item-label">杯听情况：</div>
          <div class="form-item-content">
            <cc-select :options="cupListeningOptions" v-model="cupListeningSet" placeholder="请选择杯听情况"
                       :width="130"></cc-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">订单备注：</div>
          <div class="form-item-content">
          <textarea v-model="userNote" class="am-input" rows="6" cols="30">
          </textarea>
          </div>
          <div class="form-item-label ">
            <a class="am-margin-left-sm" href="javascript:void(0)" @click="userNote+='餐具份数：'"><span>餐具份数</span></a>
          </div>
        </div>
        <!--下单方式-->
        <div class="form-item" v-show="orderPayChildOptions.length&&!isAmend">
          <div class="form-item-label">下单方式：</div>
          <div class="form-item-content">
            <cc-select :options="orderPayChildOptions" v-model="orderPayChild" placeholder="请选择下单方式"
                       :width="130"></cc-select>
          </div>
        </div>
        <!--实际下单渠道-->
        <div class="form-item" v-show="actualOrderChannel&&!isAmend">
        <!-- <div class="form-item" v-show="!isAmend"> -->
          <div class="form-item-label">实际下单渠道</div>
          <div class="form-item-content">
            <cc-select :options="channelList" labelKey="name" valueKey="id" v-model="actualOrderChannelType" placeholder="请选择"
                       :width="130"></cc-select>
          </div>
        </div>

        <!-- 商家备注 -->
        <div class="form-item" v-if="isBX">
          <div class="form-item-label">商家备注：</div>
          <div class="form-item-content">
            <textarea v-model="storeNoteContent" class="am-input" rows="6" cols="30">
            </textarea>
            <p class="tip">{{'*订单备注：客户的订单备注/要求' }}</p>
            <p class="tip">{{'商家备注：门店内部使用的订单备注/标记' }}</p>
          </div>
        </div>
      </div>
    </Card>
    <div class="am-text-center am-padding-vertical-sm" style="background-color: #ebedef">
      <Button type="info" size="large" @click.native="checkOrder">核对订单</Button>
    </div>
    <!--核对订单-->
    <Modal v-model="orderVisible" width="850px">
      <div slot="header">核对订单</div>
      <div v-if="orderVisible" class="order">
        <div class="order-pane">
          <div class="order-pane-title">
            餐品
          </div>
          <div class="am-g am-g-collapse am-padding-horizontal-sm" style="max-height: 200px; overflow-y: auto">
            <div class="am-u-sm-12 order-cart-title am-margin-vertical-xs">
              <div class="am-u-sm-1">份数</div>
              <div class="am-u-sm-5">餐品</div>
              <div class="am-u-sm-3">总价</div>
              <div class="am-u-sm-3">餐品备注</div>
            </div>
            <div class="am-u-sm-12 order-cart-item am-margin-vertical-xs" v-for="(item, key) in products" :key="key">
              <div class="am-u-sm-1">{{item.num}}份</div>
              <div class="am-u-sm-5">{{item.name}}</div>
              <div class="am-u-sm-3">{{currency}}{{item.totalProductPrice}}</div>
              <div class="am-u-sm-3">{{item._remark}}</div>
              <template v-if="item.isRequirement">
                <div class="am-u-sm-11 am-u-sm-offset-1">
                    <!-- <span class="am-fl am-padding-left-sm">{{ '特殊要求' | lang }}：</span> -->
                    <span class="am-fl">
                      {{ item.desc.join('/') }}
                      <!-- <span v-for="(text, index) in item.desc" :key="index" class="am-padding-left-sm">
                        {{text}}
                      </span> -->
                  </span>
                  </div>
              </template>
              <template v-else-if="item.type === 2">
                <div class="am-u-sm-12 am-margin-vertical-sm">
                  <div class="am-u-sm-12" v-for="(product, index) in item.products" :key="index">
                    <div class="am-u-sm-1">{{product.num}}</div>
                    <div class="am-u-sm-11"><span>-{{product.name}} </span></div>
                    <!-- <div class="am-u-sm-3">{{currency}}{{product.totalProductPrice}}</div> -->
                    <div class="am-u-sm-12 am-padding-top-sm" v-if="product.desc">
                      <!-- <span class="am-fl am-padding-left-sm">{{ '特殊要求' | lang }}：</span> -->
                      <div class="am-u-sm-11 am-u-sm-offset-1">
                        {{ product.desc.join('/') }}
                        <!-- <span v-for="(text, index) in product.desc" :key="index" class="am-padding-left-sm">{{text}}</span> -->
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="order-pane">
          <div class="order-pane-title">
            其他费用
          </div>
          <div class="am-g am-padding-horizontal-sm">
            <p class="am-margin-vertical-xs" v-show="isDelivery|| orderType=== 1 || orderType === 4">
              <span>配送费：</span>
              <span class="prefix-price-unit">{{currency}}{{deliveryFee | formatPrice(true)}}</span>
            </p>
            <p class="am-margin-vertical-xs" v-show="fee.mealFee">
              <span>餐盒费：</span>
              <span class="prefix-price-unit">{{currency}}{{fee.mealFee | formatPrice(true)}}</span>
            </p>
            <p class="am-margin-vertical-xs" v-show="raisePriceTotal">
              <span>
                满加：
              </span>
              <span class="prefix-price-unit">
                {{currency}}{{raisePriceTotal | formatPrice(true)}}
              </span>
            </p>
            <p class="am-margin-vertical-xs" v-show="subtractAmount">
              <span>
                优惠总金额：
              </span>
              <span class="prefix-price-unit">
                {{currency}}{{subtractAmount | formatPrice(true)}}
              </span>
            </p>
            <p class="am-margin-vertical-xs" v-show="cardMsg">
              <span>
                优惠卡：
              </span>
              <span>
                {{cardMsg}}
              </span>
            </p>
            <p class="am-margin-vertical-xs order-total order-text-orange">
              <span>
                顾客需付：
              </span>
              <template v-if="!isOnlinePay&&isAmend">
                ({{orderOfflinePayTypeOptions | offlinePaysStr}})
              </template>
              <template v-else>
                <span class="prefix-price-unit" >
                  {{currency}}{{total | formatPrice(true)}}
                  <template v-if="isSaveOfflinePays&&payType=== 1">
                    ({{offlinePayModal.paymentDetails | offlinePaysStr}})
                  </template>
                  <template v-else>
                    ({{payChildTypeName}})
                  </template>
                </span>
              </template>
            </p>
          </div>
        </div>
        <div class="order-pane">
          <div class="order-pane-title">
            收货地址
          </div>
          <div class="am-g am-padding-horizontal-sm">
            <p class="am-margin-vertical-xs">
              <span>收货人：</span>
              <span>{{name}}</span>
            </p>
            <p class="am-margin-vertical-xs">
              <span>收货人电话：</span>
              <span v-if="countryCode" style="margin-right: 10px;border-right: 1px solid #ccc;padding-right: 10px;">{{countryCode}}</span>
              <span>{{phone}}</span>
            </p>
            <p class="am-margin-vertical-xs">
              <template v-if="sendType === 2">
                <span>门店地址：</span>
                <span>
                     {{store.storeAddress}}
                  </span>
              </template>
              <template v-else>
                <span>收货地址：</span>
                <span>
                    {{address}}
                  </span>
              </template>
            </p>
            <p class="am-margin-vertical-xs" v-if="!isAmend">
              <template v-if="orderType === 1">
                <span>订单预计：</span>
                <span>在<span class="order-delivery order-text-orange">{{store.waitTime}}分钟</span>到达</span>
              </template>
              <template v-else-if="orderType === 4">
                <span>外卖预约：</span>
                <span>订单预计在<span class="order-delivery order-text-orange">{{selfGetTime}}</span>左右送达</span>
              </template>
              <template v-else>
                <span>
                  自取：
                </span>
                <span>
                  请在<span class="order-delivery order-text-orange">{{selfGetTime}}</span>左右到门店取餐
                </span>
              </template>
            </p>
          </div>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <Button @click.native="saveOrder" :loading="submitLoading">提交订单</Button>
        <Button @click.native="orderVisible= false" class="am-btn-cancel">返回修改</Button>
      </div>
    </Modal>
    <!--修改订单支付弹框-->
    <Modal v-model="orderAmendPayModal.visible" width="850px">
      <div slot="header">修改支付方式</div>
      <div class="order-amend-pay">
        <div class="order-amend-hint">说明：请根据客户需求,调整具体各线下支付类型金额</div>
        <div class="form am-margin-top-xs">
          <div class="form-item am-margin-bottom-0">
            <div class="form-item-label">订单应收：</div>
            <div class="form-item-content prefix-price-unit am-color-price">{{currency}}{{orderAmendPayModal.total}}</div>
          </div>
          <div class="form-item am-margin-bottom-0">
            <div class="form-item-label">订单实收：</div>
            <div class="form-item-content">
              <CheckboxGroup v-model="orderAmendPayModal.payCheck" class="am-flex am-flex-column">
                <Checkbox v-for="item in orderAmendPayModal.paymentDetails" :key="item.value" :label="item.value"
                          class="am-margin-top-xs">
                  <div class="am-inline-block am-text-not-line" slot-scope="{ currentValue }">
                    <div class="am-padding-left-xs am-padding-right-sm am-inline-block w150">{{item.label}}</div>
                    <Input v-model="item.money" :disabled="!currentValue"/>
                  </div>
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <Button @click.native="calculatePayMoney">确认</Button>
        <Button @click.native="orderAmendPayModal.visible = false" class="am-btn-cancel">取消</Button>
      </div>
    </Modal>
    <!-- 补充更多线下支付-->
    <Modal  @on-visible-change="offlinePayModalChange" v-model="offlinePayModal.visible" width="850px">
      <div slot="header">补充更多支付方式</div>
      <div class="offline-pay am-g-collapse am-cf">
        <div class="offline-pay-hint">*请根据顾客需要选择对应的线下支付方式，提交订单后顾客后续若未进行扫码支付，订单将记录选择的支付方式</div>
        <div class="offline-pay-info am-padding-vertical-sm am-u-sm-12">
          <div class="am-u-sm-4">
            <span>顾客需付：</span>
            <span class="prefix-price-unit am-color-price">{{currency}}{{total | formatPrice(true)}}</span>
          </div>
          <div class="am-u-sm-4">
            <span>目前总额：</span>
            <span class="prefix-price-unit am-color-price">{{currency}}{{offlinePayModal.total | formatPrice(true)}}</span>
          </div>
          <div class="am-u-sm-4">
            <span class="am-color-price">还差：</span>
            <span class="prefix-price-unit am-color-price">{{currency}}{{offlinePayModal.difference | formatPrice(true)}}</span>
          </div>
        </div>
        <div class="am-u-sm-12 offline-pay-content" >
          <div class="am-u-sm-12 offline-pay-header ">
            <div class="am-u-sm-4"><checkbox class="am-padding-left-sm" v-model="offlinePayModal.isAllCheck" isAllCheck @change="offlinePayAllCheckChange">操作</checkbox></div>
            <div class="am-u-sm-8 ">支付金额</div>
          </div>
          <div class="offline-pay-form  am-padding-bottom-xs" >
            <checkbox-group class="am-flex am-flex-column offline-pay-form-group" v-model="offlinePayModal.payCheck" @on-change="offlinePayChange">
              <div class="offline-pay-form-item am-margin-top-xs" v-for="item in offlinePayModal.paymentDetails" :key="item.value">
                <div class="am-inline-block am-padding-left-sm w-u-4">
                  <Checkbox   :label="item.value" class="am-margin-top-xs " >
                    <span>{{item.label}}</span>
                  </Checkbox>
                </div>
                <Input v-model="item.money" :disabled="item.disabled" @on-blur="verifyOfflinePay(item)" :placeholder="item.placeholder"  type="number" class="w-u-4"/>
                <div class="am-inline-block am-padding-left-xs" v-if="item.error">
                  <div class=" am-color-warning" >{{item.error}}</div>
                </div>
              </div>
            </checkbox-group>
          </div>
        </div>
      </div>
      <div slot="footer" class="am-text-center">
        <Button @click.native="saveOfflinePayModal">确认</Button>
        <Button @click.native="offlinePayModal.visible = false" class="am-btn-cancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {round} from 'mathjs'
  import {each, format, throttle, isTel, isDisabled, formatPrice, find, calculateNum, isBaXi, getUrlParameter} from '@/utils/assist'
  import Card from '@/components/Card/index'
  import Input from '@/components/Input/index'
  import CcSelect from '@/components/Select/index'
  import Button from '@/components/Button'
  import Radio from '@/components/Radio/index'
  import RadioGroup from '@/components/RadioGroup/index'
  import CheckboxGroup from '@/components/CheckboxGroup/index'
  import Checkbox from '@/components/Checkbox/index'
  import Modal from '@/components/Modal'
  import lib from '@/lib/server'
  const initData = {
    orderPayChild: null, // 下单方式
    orderVisible: false, // 核对订单的显隐
    payType: null, // 支付类型
    payChildType: null, // 对应支付子类型
    invoiceType: 0, // 发票类型
    invoiceDesc: null, // 发票描述
    taxNo: null, // 发票税号
    taste: null, // 订单备注
    oldTaste: null, // 旧的订单备注
    userNote: '', // 用户喜好
    submitLoading: false,
    cupListeningSet: 1, // 杯听
    actualOrderChannelType:null,//实际下单渠道
    cupListeningOptions: [
      {
        label: '不选',
        value: 1
      },
      {
        label: '可乐（杯）',
        value: 2
      },
      {
        label: '可乐（听）',
        value: 3
      }
    ], // 杯听选择
    oldOrderData: {
      isInvoice: false, // 旧的发票数据
      invoiceDesc: '',
      taxNo: '',
      invoiceType: 1,
      sendTime: ''
    },
    orderOfflinePayTypeOptions: [], // 线下支付
    orderAmendPayModal: {
      visible: false,
      total: 0,
      payCheck: [],
      paymentDetails: []
    },
    isSaveOfflinePays: false, // 线下支付保存情况
    offlinePayModal: {  // 线下支付的他弹框
      visible: false,
      total: 0,
      payCheck: [],
      paymentDetails: [],
      difference: 0,
      isAllCheck: false
    },
    storeNoteContent:"" // 商家备注
  };
  let isUpdateDefaultTime = false; // 是否自动更新
  export default {
    name: 'moreInfo',
    inject: ['products'],
    props: {
      vipVolumeKey: {
        type: Number
      },
      isVipVolume: {
        type: Boolean
      },
      deliveryFee: {
        type: Number
      },
      isDelivery: {
        type: Boolean
      },
      cokeKey: {
        type: Number
      },
      isColaCupConversionListeningSet: {
        type: Boolean
      },
      isAmend: {
        type: Boolean
      },
      isAddCart: { // 是否可以添进购物车
        type: Boolean
      }
    },
    filters: {
      formatPrice,
      offlinePaysStr (list = []) {
        let arr = [];
        each(list, item => {
          if(!item.disabled) {
            arr.push(`${item.label}${window.currency}${item.money}`)
          }
        });
        return arr.join(',');
      }
    },
    created() {
      this.getPlatformByKey();
      this.oldTaste = this.taste = this.user.taste || '';
      this.$on('order-update', (o) => {
        this.init(o)
      })
    },
    data() {
      return {
        currency: window.currency,
        orderType: null, // 下单类型
        selfGetTime: null, // 预约或自取的(日期+时间)
        storeTimeList: [], // 可选时间列表
        storeDateValue: null, // 日期选中值
        storeTimeValue: null, // 时间选种植
        channelList: [], // 渠道列表
        ...initData,
        isBX:false // 是否八喜
      }
    },
    mounted() {
      let urlData = getUrlParameter();
      this.isBX = isBaXi(urlData.platformKey || this.brandInfo.platformKey)
    },
    computed: {
      fee() {
        return this.cart.fee
      },
      //优惠总金额
      subtractAmount() {
        let {cart, total} = this,
          {fee} = cart,
          sum = 0;
        sum = fee.products + fee.delivery + fee.mealFee;
        return formatPrice(sum - total > 0 ? sum - total : 0)
      },
      businessType() {
        let store = this.store,
          businessType = store.businessType,
          o = {};
        if (businessType) {
          each(businessType, (value) => {
            o[value] = true
          })
        }
        return o
      },
      // 支付类型选项
      payOptions() {
        let {payTypeName, payType} = this.store,
          isOffline = false,
          pays = [];
        each(payType, value => {
          if (value === 1) isOffline = true;
          let label = payTypeName[value];
          if (label) pays.push({value, label})
        });
        if (!isOffline) {
          pays.unshift({value: 1, label: '线下支付'})
        }
        return pays
      },
      // 对应子支付类型
      payChildOptions() {
        let {payType, offlinePayTypeOptions, onLinePayTypeOptions} = this,
          pays = [];
        payType *= 1;
        if (payType === 1) {
          pays = offlinePayTypeOptions
        } else if (payType === 2) {
          pays = onLinePayTypeOptions
        }
        return pays
      },
      // 线上支付类型
      onLinePayTypeOptions() {
        let {onLinePayType} = this.store,
          onLinePayTypeName = {1: '支付宝', 2: '微信'},
          onLinePayTypeMap = [];
        each(onLinePayType, value => {
          let label = onLinePayTypeName[value];
          if (label) onLinePayTypeMap.push({value, label})
        });
        return onLinePayTypeMap
      },
      // 线下支付选项
      offlinePayTypeOptions() {
        let {platformOfflinePayTypes = []} = this.store;
        return platformOfflinePayTypes.map((item) => {
          return {value: item.id, label: item.name}
        })
      },
      // 线下支付类型名字
      payChildTypeName() {
        let name = '',
          {payChildType, payChildOptions} = this;
        find(payChildOptions, value => {
          if (value.value * 1 === payChildType * 1) return name = value.label
        });
        return name
      },
      // 下单方式列表
      orderPayChildOptions() {
        // 排除现金、刷卡、支票、现金、余额卡、微众
        let offlinePayTypeOption = this.offlinePayTypeOptions,
          list = [],
          excludes = {
            1: true,
            2: true,
            3: true,
            4: true,
            30: true,
            31: true
          };
        find(offlinePayTypeOption, (item) => {
          if (!excludes[item.value]) list.push(item)
        });
        if (list.length > 0) {
          list.unshift({
            label: '不选',
            value: 1
          })
        }
        return list
      },
      //实际下单方式
      // actualOrderChannelTypeOptions(){

      // },
      // 优惠满加
      raisePriceTotal() {
        let sum = 0,
          list = this.preferential.list;
        each(list, (value) => {
          if (value.type === 2) sum += value.price
        });
        return formatPrice(sum)
      },
      total() {
        return this.preferential.total
      },
      // 优惠卡
      cardMsg() {
        return this.preferential.cardMsg
      },
      isOnlinePay() {
        return this.orderAmend.isOnlinePay
      },
      ...mapState({
        orderAmend: state => state.booking.user.orderAmend,
        storeDateList: state => state.booking.user.storeDateList,
        preferential: state => state.booking.preferential,
        cart: state => state.booking.cart,
        vipPhone: state => state.booking.user.vipPhone,
        phone: state => state.booking.user.phone,
        countryCode: state => state.booking.user.countryCode,
        name: state => state.booking.user.name,
        address: state => state.booking.user.address, // 地址
        user: state => state.booking.user.data, // 用户信息
        sendType: state => state.booking.user.sendType, // 业务
        store: state => state.booking.store.data, // 门店
        storeId: state => state.booking.user.storeId, // 门店ID
        longitude: state => state.booking.user.longitude, // 经度
        latitude: state => state.booking.user.latitude, // 纬度
        reserveDate: state => state.booking.user.reserveDate, // 业务选择的时间
        isNeedTableware: state => state.booking.user.isNeedTableware, // 是否餐具回收
        districtDetailsAddress: state => state.booking.user.districtDetailsAddress,
        brandInfo: state => state.booking.user.brandInfo,
        actualOrderChannel: state => state.booking.user.oprInfo.actualOrderChannel,// 实际下单渠道
        oprInfo: state => state.booking.user.oprInfo, // 营运商配置信息
      }),
      isJYJForXL() {
        return (!window.standardDB && (this.brandInfo.platformKey === 'cfffb941289a08f9(' || this.brandInfo.platformKey === '0198e4d9557e9a23')) || (window.standardDB && (this.brandInfo.platformKey === 'b93a3d359a795d9c' || this.brandInfo.platformKey === 'eed84f190fa141e6'))
      },
    },
    watch: {
      // 支付类型子项的变化
      payChildOptions() {
        let arr = this.payChildOptions;
        this.payChildType = arr.length > 0 ? arr[0].value : null;
      }
    },
    methods: {
      getPlatformByKey() {
        // 获取运营商配置
        let oprInfo = this.oprInfo,
          channelIdAll = [],
          channelList = [{id:null,name:"请选择"}].concat(oprInfo.channelListOfExternal, oprInfo.channelList);
          oprInfo.posType.forEach((item) => {
            if(item.isOrder){
              channelList.push(item);
            }
          });
        channelList.forEach((item) => {
          item.label = item.name;
          channelIdAll.push(item.id)
        });
        // this.channelIdAll = channelIdAll;
        this.channelList = channelList;
        // this.form.fromTypeList = [...channelIdAll];
      },
      offlinePayAllCheckChange (status) { // 线下支付全选变化
        let offlinePayModal = this.offlinePayModal,
          isAllCheck = false,
          { paymentDetails } = offlinePayModal,
          payCheck = status ? paymentDetails.map(pay => pay.value) : [];
        offlinePayModal.isAllCheck = status;
        offlinePayModal.payCheck = payCheck;
        this.calculateOfflinePay();
      },
      offlinePayModalChange (status) { // 线下支付的弹框变化
        if (!status) {
          let offlinePayModal = this.offlinePayModal,
            { total, paymentDetails, payCheck } = offlinePayModal;
          if (!this.isSaveOfflinePays || total === 0) {
            this.initOfflinePayModalData(this.offlinePayTypeOptions);
            this.$emit('updatePayType', this.payChildType === 12 ? [1, 12]: []);
          } else {
            let selectObj = [], checkId= {};
            each(payCheck, id=> {
              checkId[id] = true;
            });
            each(paymentDetails, pay => {
              if (checkId[pay.value]&&pay.money > 0&&!pay.error) {
                selectObj.push(pay.value);
              }
            });
            if (payCheck.length !== selectObj.length) {
              payCheck.splice(0, payCheck.length, ...selectObj);
              this.calculateOfflinePay();
            }
          }
        } else {
          this.calculateOfflinePay();
        }
      },
      payChange (payType) { // 支付类型改变
        if (payType !== 1&& this.isSaveOfflinePays) this.initOfflinePayModalData(this.offlinePayTypeOptions);
        if (payType !== 1) this.$emit('updatePayType', []);
      },
      initOfflinePayModalData (offlinePayTypeOptions) { // 初始化线下支付类型
        let paymentDetails = [];
        each(offlinePayTypeOptions, pay =>{
          paymentDetails.push({...pay, disabled: true, money: '', placeholder: '请选择此支付方式后填写', error: ''});
        });
        Object.assign(this.offlinePayModal, {
          total: 0,
          paymentDetails,
          payCheck: [],
          desc: '',
          isAllCheck: false
        });
        this.isSaveOfflinePays = false;
      },
      showOfflinePayModal () { // 显示线下支付金额的弹框
        let offlinePayModal = this.offlinePayModal,
          { total } = offlinePayModal;
        Object.assign(offlinePayModal, {
          visible: true,
          difference: formatPrice(calculateNum(this.total, total, '-'))
        })
      },
      verifyOfflinePay (item) { // 验证线下支付金额的争取
        let money = Number(item.money), error = '', max = this.total, id = item.value,{ paymentDetails} = this.offlinePayModal, numList = [];
        each(paymentDetails, pay => {
          if (!pay.disabled&&pay.value !== id) {
            numList.push(pay.money)
          }
        });
        max = calculateNum(max, ...numList, '-');
        if (isNaN(money)) {
          error = '请输入正确的数字';
        } else if (money <= 0) {
          error = '支付金额必须大于0';
        } else if (money > max){
          error = '不可大于顾客需付金额';
        } else {
          money = round(money,window.oprInfo.accuracy || 2);
          item.error = '';
          this.calculateOfflinePay();
        }
        item.money = money || '';
        item.error = error;
      },
      offlinePayChange () { // 线下支付子类型的勾选
        this.calculateOfflinePay();
      },
      calculateOfflinePay () { // 计算线下支付子类型金额
        let offlinePayModal = this.offlinePayModal,
          { paymentDetails, payCheck} = offlinePayModal,
          isSatisfy = false, // 是否符合
          total = 0, // 统计金额
          moneyList = [], // 选中填写的金额列表
          list = [],
          count = 0,
          difference = 0,
          checkId = {};
        each(payCheck, id => {
          checkId[id] = true;
        });
        each(paymentDetails, pay=> {
          let id = pay.value, money = pay.money;
          if (checkId[id]&&money>0){
            moneyList.push(money);
          }
        });
        total = calculateNum(...moneyList, '+');
        if (this.total>=total) isSatisfy = true;
        this.$emit('updatePayType', checkId[12] ? [1, 12]: []);
        each(paymentDetails, pay => {
          let id = pay.value, placeholder = '请选择此支付方式后填写', disabled = true, money = '', error = '';
          if (checkId[id]&&(!pay.error || isSatisfy)) {
            money = pay.money;
            error = pay.money > 0 ? false : pay.error;
            list.push(money)
          }
          if (checkId[id]) {
            disabled = false;
            placeholder = '请输入支付金额';
          }
          Object.assign(pay, {
            money,
            placeholder,
            disabled,
            error
          });
        });
        setTimeout(()=> {  //延迟获取平安银行导致的配送费
          let total = this.total;
          count = formatPrice(calculateNum(...list, '+'));
          difference = formatPrice(calculateNum(total, count, '-'));
          Object.assign(offlinePayModal, {
            total:formatPrice(count),
            difference,
            isAllCheck: payCheck.length === paymentDetails.length
          });
        }, 100);
      },
      saveOfflinePayModal () { // 保存线下支付类型
        let offlinePayModal = this.offlinePayModal,
            total = this.total,
            error = false,
            checkId = {},
            errorItem,
            payCheck = offlinePayModal.payCheck,
            count = offlinePayModal.total;
        each(payCheck, id => {
          checkId[id] = true;
        });
        each(offlinePayModal.paymentDetails, pay => {
          if (pay.error) error = true;
          if (!errorItem&&checkId[pay.value]&&pay.money <= 0) errorItem = pay;
        });
        if (errorItem) return this.verifyOfflinePay(errorItem);
        if ( payCheck.length === 0 || error || total !== count||  count === 0 ) {
          let msg = payCheck.length === 0 ? '支付方式必须勾选一个' : (error || total !== count) ? '各支付方式金额总和应当等于订单总额，请重新设置再保存！' : '支付金额不能为0';
            this.$Modal.error({title: '提示', content: msg})
        } else {
          this.isSaveOfflinePays = true;
          offlinePayModal.visible = false;
        }
      },
      calculatePayMoney() { // 改单计算线下支付金额
        let orderOfflinePayTypeOptions = this.orderOfflinePayTypeOptions,
          isPingAnBank = false,
          orderAmendPayModal = this.orderAmendPayModal,
          {payCheck, total, paymentDetails} = orderAmendPayModal,
          count = 0,
          selectObj = {};
        each(payCheck, (value) => {
          selectObj[value] = true;
        });
        each(paymentDetails, (pay) => {
          let value = pay.value,
            money = Number(pay.money);
          if (selectObj[value]) {
            if (value === 12) isPingAnBank = true;
            count += money;
            selectObj[value] = money;
          }
        });
        if (count !== total) {
          this.$Modal.error({title: '提示', content: '各支付方式金额总和应当等于订单总额，请重新设置再保存！'})
        } else {
          each(orderOfflinePayTypeOptions, pay => {
            let value = pay.value, disabled = true, money = 0;
            if (selectObj.hasOwnProperty(value)) {
              money = selectObj[value];
              disabled = false;
            }
            pay.disabled = disabled;
            pay.money = money;
          });
          orderAmendPayModal.visible = false;
        }
        //this.$emit('updatePayType', isPingAnBank ? [1, 12]: [])
      },
      showOrderAmendPayModal() { // 显示需改线下支付信息
        let orderAmendPayModal = this.orderAmendPayModal,
          total = this.total,
          paymentDetails = [],
          payCheck = [],
          orderOfflinePayTypeOptions = this.orderOfflinePayTypeOptions;
        each(orderOfflinePayTypeOptions, pay => {
          if (!pay.disabled) {
            payCheck.push(pay.value)
          }
          paymentDetails.push(pay)
        });
        Object.assign(orderAmendPayModal, {
          visible: true,
          paymentDetails,
          payCheck,
          total
        });
      },
      init({isStore, isOrderType, isClear, isAmend}) {
        let {storeDateList, payOptions, sendType, offlinePayTypeOptions} = this;
        let value = sendType === 2 || sendType === 4 ? 0 : null;
        if (isStore || isClear) {
          // 首选线下支付
          let index = payOptions.findIndex(item => {
            return item.value * 1 === 1
          });
          index = index > -1 ? index : 0;
          this.payType = payOptions.length && payOptions[index].value;
          this.initOfflinePayModalData(offlinePayTypeOptions);
        }
        // 业务时间
        if (isStore || isOrderType || isClear) {
          if (storeDateList.length > 0 && typeof value === 'number') {
            this.storeDateValue = value;
            this.storeTimeList = storeDateList[value].list;
            this.storeTimeValue = 0;
          }
        }
        // 修改订单信息回显
        if (isAmend) { // 还原门店
          let orderAmend = this.orderAmend,
            isPingAnBank = false,
            {isOnlinePay, orderData} = orderAmend,
            {paymentDetails = [], isInvoice, invoiceDesc = '', taxNo = '', cupListeningSet, userNote, invoiceType, sendTime,storeNoteContent} = orderData;
          if (isInvoice) {
            this.invoiceDesc = invoiceDesc;
            this.taxNo = taxNo;
          }
          if (!isOnlinePay && Array.isArray(paymentDetails)) {
            let payObj = {}, pays = [];
            each(offlinePayTypeOptions, pay => {
              payObj[pay.value] = {...pay, disabled: true, money: 0};
            });
            each(paymentDetails, pay => {
              let type = pay.type;
              if (type === 12) isPingAnBank = true;
              if (payObj[type]) {
                payObj[type] = {...payObj[type], disabled: false, money: pay.money};
              }
            });
            each(payObj, pay => {
              pays.push(pay)
            });
            this.orderOfflinePayTypeOptions = pays;
          }
          this.oldOrderData = {
            isInvoice: isInvoice, // 旧的发票数据
            invoiceDesc: invoiceDesc,
            taxNo: taxNo,
            invoiceType: invoiceType,
            sendTime
          };
          this.userNote = userNote;
          this.storeNoteContent = storeNoteContent
          this.cupListeningSet = cupListeningSet;
          this.invoiceType = isInvoice ? invoiceType : 0;
          //this.$emit('updatePayType', isPingAnBank ? [1, 12]: [])
        }
        this.orderType = sendType;
        isUpdateDefaultTime = true; // 是否自动更新时间
      },
      changeOrderType(type) {
        // 类型改变，进行数据重新拉取
        if (this.sendType !== type) {
          this.$store.dispatch('booking/user/update', {
            sendType: this.orderType
          });
          this.$emit('update', this.orderType)
        }
      },
      // 支付子类型改变
      payChildChange(payChildType) {
        let payType = this.payType;
        this.$emit('updatePayType', [payType, payChildType]);
      },
      handleCheckDate(value, label, item) {
        //选择日期
        if (item && item.hasOwnProperty('list')) {
          let list = item.list || [],
            timeValue = null,
            current;
          if (isUpdateDefaultTime) timeValue = list.length ? 0 : null;
          this.storeTimeList = [...list];
          this.storeTimeValue =  timeValue;
          if (isUpdateDefaultTime) {
             current = list[0];
            list.length && this.handleCheckTime(current.value, current.label);
          }
          isUpdateDefaultTime = false;
        }
      },
      handleCheckTime(id, time) {
        // 选择时间
        if (id !== null && time !== null) {
          let {storeDateList, storeDateValue, orderType} = this,
            date = storeDateList[storeDateValue].label + ' ' + time;
          this.$store.dispatch('booking/user/update', {
            reserveDate: format(Date.parse(date))
          });
          if ((orderType === 4 || orderType === 2)&&!isUpdateDefaultTime) this.$emit('update');
          isUpdateDefaultTime = false;
        }

      },
      async checkOrder() {
        //审核订单
        let {store, cart, isSaveOfflinePays, payType,  offlinePayModal,storeTimeValue, districtDetailsAddress, orderType, name, vipPhone, phone,countryCode, address, reserveDate, fee, businessType, invoiceType, invoiceDesc, taxNo, isOnlinePay, isAmend, orderOfflinePayTypeOptions, longitude, latitude,actualOrderChannelType} = this,
          _this = this,
          requestList = this.server.requestList,
          cancelList = requestList[lib['getCanPreList']] || [], // 优惠请求列表 默认空数组，因为改单的时候，是不会触发优惠接口
          {deliveryType, reachPart, reachFee, waitTime, takeSelf, storeAddress} = store,
          total = cart.count.total,
          msg,
          state = true,
          validateList = [],
          selfGetTime;
        address = orderType === 2 ? storeAddress : address;
        validateList = [
          function () {
            if (isSaveOfflinePays&&payType === 1&&offlinePayModal.total !== _this.total) { // 判断线下支付是否正确
              state = false;
              msg = '各支付方式金额总和应当等于订单总额，请重新设置再保存！'
            }
          },
          function () {
            if (invoiceType === 2 && (!invoiceDesc || !taxNo)) {
              state = false;
              msg = invoiceDesc ? '' : '发票抬头不能为空';
              msg += taxNo ? '' : '发票税号不能为空';
            }
          },
          function () {
            // 不满足配送条件 1、餐品数量 2、餐品金额
            // 不满足配送条件 堂食自取忽略
            if ((orderType!==2&&orderType!==3)&&((deliveryType === 1 && reachPart > total) || (deliveryType === 2 && reachFee > fee.products))){
              state = false;
              msg = '未达到起送条件'
            }
          },
          function () {
            // 至少点选一个餐品
            if (total < 1) {
              state = false;
              msg = '请至少选择一份餐品'
            }
          },
          function () {
            if (isAmend && !isOnlinePay) { // 支付金额判断
              let count = 0;
              each(orderOfflinePayTypeOptions, pay => {
                if (!pay.disabled) count += pay.money;
              });
              if (count !== _this.total) {
                state = false;
                msg = '各支付方式金额总和应当等于订单总额，请重新设置再保存！'
              }
            }
          },
          function () {
            if (businessType[orderType]) {
              //当前业务门店是否支持
              if (!isAmend) {
                if (orderType !== 1) {
                  // 不是外卖  reserveData 选中时间  practicalDate实际时间
                  waitTime = orderType === 4 ? waitTime : takeSelf.minTime;
                  let practicalDate = Date.now() + (waitTime - 5) * 60 * 1000,
                    typeStr = orderType === 4 ? '预送达时间' : '自取时间',
                    appointmentTime = new Date(reserveDate).getTime();
                  if (storeTimeValue === null) {
                    msg =`请选择${typeStr}`;
                    state = false;
                    return
                  }
                  if (practicalDate > appointmentTime) {
                    state = false;
                    msg = `由于点餐时间过长，${typeStr}已失效，请重新选择${typeStr}`
                  }
                  selfGetTime = appointmentTime
                } else {
                  selfGetTime = format(waitTime * 60 * 1000 + Date.now())
                }
              }
            } else {
              state = false;
              msg = '当前门店不支持当前业务，不可以下单，请更换门店'
            }
          },
        ];
        for (let i = 0, len = validateList.length; i < len; i++) {
          if (typeof validateList[i] === 'function' && state) validateList[i]()
        }
        if (cancelList.length > 0) { state = false; msg = '用户优惠计算中, 请稍等再提交' } // 判断优惠接口是否请求完毕
        // 顾客信息不足
        if (!name || !/^(\d{8}|\d{10}|\d{11}|(\d{3,4}-\d{8}))$/.test(phone) || !address) {
          state = false;
          msg = '顾客信息未填写完全，将会影响门店配送或顾客就餐';
          this.$Modal.confirm({
            title: '提示',
            content: msg,
            okText: '补全信息',
            cancelText: '取消',
            onOk: () => {
              this.$router.push({name: 'customer'})
            }
          });
          return
        }
        // 由于点餐时间过长，预约和自取时间
        this.selfGetTime = format(selfGetTime)
        if (state && (orderType === 1 || orderType === 4)) {
          // 外卖 外卖预约 判断地址是否在范围内
          // 请求门店是否在配送范围内
          let cityName = '';
              each(districtDetailsAddress.match(/.+?(省|市|自治区|自治州|县|区)/g), function (value) {
                if (value.indexOf('市')>-1) cityName = value;
              });
          state = await _this.server.get({
            name: 'getStoreDeliveryRange',
            data: {
              storeId: store.storeId,
              coordinate: [longitude, latitude],
              cityName
            }
          }).then((res) => {
            let {status, data} = res;
            if (status === 1) {
              // 更新门店数据
              return data.length
            }
            return false
          }).catch(function () {
            return false
          });
          msg = isAmend ? '订单不在门店配送范围，请确定是否继续改单？' : '订单不在门店配送范围，请确认是否下单';
          if (!state) {
            return this.$Modal.confirm({
              title: '提示',
              content: msg,
              onOk: () => {
                _this.orderVisible = true;
              },
              onCancel: () => {
                _this.orderVisible = false;
              }
            });
          }
        }
        if (state) {
          //修改订单无须校验会员电话
          if(!/^(\d{8}|\d{10}|\d{11}|(\d{3,4}-\d{8}))$/.test(vipPhone) && _this.isJYJForXL && !isAmend) {
            _this.$Modal.confirm({
              title: '提示',
              content: '顾客会员电话信息未填写完全，将会影响后续积分或优惠券等到账',
              okText: '补全信息',
              cancelText: '取消',
              onOk: () => {
                _this.$router.push({name: 'customer'})
              },
            });
          } else {
            _this.orderVisible = true;
          }
        } else {
          this.$Modal.error({
            title: '提示',
            content: msg
          });
        }
      },
      saveOrder() {
        // 提交订单
        let content,
          {
            orderPayChild, // 下单方式
            orderPayChildOptions,  // 下单方式列表
            storeId, // 门店ID
            store, // 门店数据
            longitude, // 经度
            latitude, // 维度
            orderType, // 业务类型
            cart, // 购物车
            name, // 用户名
            vipPhone, //会员电话
            phone, //用户手机号码
            countryCode,//用户手机区号
            user,
            payType, // 支付类型
            invoiceType, // 发票类型
            invoiceDesc, // 发票描述
            taxNo, // 发票号
            userNote,  // 用户备注
            preferential, // 优惠
            selfGetTime, // 自取时间
            address, // 地址
            payChildType, // 对应子支付类型
            payChildTypeName, // 子支付类型名字
            total, // 总数
            isNeedTableware, // 是否需要餐具
            isVipVolume,  // 是否开启贵宾卷
            vipVolumeKey, // 贵宾卷的餐品key
            cupListeningSet, // 杯听选择
            isColaCupConversionListeningSet, // 是否定制杯听
            cokeKey, //定制可乐ID
            isAmend, // 是否编辑订单
            isOnlinePay,
            orderOfflinePayTypeOptions,
            orderAmend,
            isSaveOfflinePays,
            isAddCart, // 是否可以添进购物车
            actualOrderChannelType, // 实际下单渠道
            storeNoteContent // 商家备注
          } = this,
          urlName = 'getPostOrder',
          isOrderPayChild,
          fromTypeNote = '',
          {manualPreferentials, pres, cardNum} = preferential,
          {uid} = user,
          {menuId} = cart,
          userId = uid,
          type = orderType,
          randomCode = Date.now(),
          products = [...cart._products],
          cardCode = cardNum,
          isInvoice = invoiceType > 0,
          paymentDetails = [
            {
              type: payChildType,
              typeName: payChildTypeName,
              money: total
            }
          ];
        // 是否支持可乐杯听情况
        if (isColaCupConversionListeningSet && cupListeningSet === 1 && cokeKey) {
          let total = 0;
          each(this.products, product => {
            if (product.uid === cokeKey) {
              total = product.num * 1;
            }
          });
          cupListeningSet = total === 0 ? 1 : total < 12 ? 2 : 3;
        }
        // 餐具回收提示
        if (isNeedTableware && total > 0) {
          this.$Modal.error({
            title: '提示',
            content: '餐具回收，订单金额需为0。可通过手动打折减免金额'
          });
          return
        }
        // 地址
        address = orderType === 2 ? store.storeAddress : address;
        // 手动打折
        manualPreferentials = manualPreferentials.map((value) => {
          let {type, rate, redPrice, pid, count, prePrice, content} = value;
          redPrice *= -1;
          prePrice *= -1;
          return {type, rate, redPrice, pid, count, prePrice, content}
        });
        // 合并备注
        each(this.products, (value) => {
          if (value._remark) userNote += `;${value.name}：${value._remark}`;
        });
        // 是否存在贵宾卷
        if (isVipVolume && vipVolumeKey) {
          each(this.products, product => {
            if (vipVolumeKey === product.uid) {
              products.push({
                pid: product.uid,
                typeId: product.smallTypeId || product.bigTypeId,
                num: product.num
              })
            }
          })
        }
        // 下单方式
        if (orderPayChildOptions.length && orderPayChild && orderPayChild != 1) {
          isOrderPayChild = find(orderPayChildOptions, (item) => {
            return item.value == orderPayChild;
          });
          if (isOrderPayChild) {
            fromTypeNote = isOrderPayChild.value.label
          }
        }
        if (isAmend) { // 改单提交的数据
          let unValidPro = false,
            orderId = orderAmend.orderData.orderId;
          if (!isAddCart) { // 忽略验证
            products = [];
            manualPreferentials = [];
            unValidPro = true;
          }
          paymentDetails = [];
          if (!isOnlinePay) { // 支付类型显示
            each(orderOfflinePayTypeOptions, pay => {
              let {value, disabled, label, money} = pay;
              if (!disabled) paymentDetails.push({
                type: value,
                typeName: label,
                money
              })
            })
          }
          content = {
            orderId,
            storeId,
            menuId,
            name,
            vipPhone,
            phone,
            countryCode,
            address,
            longitude,
            latitude,
            cupListeningSet,
            paymentDetails,
            isInvoice,
            invoiceType,
            invoiceDesc,
            taxNo,
            userNote,
            isNeedTableware: isNeedTableware ? 1 : 0,
            unValidPro,
            products,
            manualPreferentials,
            storeNoteContent
          };
          urlName = 'changeOrder';
        } else {
          // 正常提交订单
          if (isSaveOfflinePays&&payType === 1) { // 是否多种线下支付类型
            paymentDetails = [];
            each(this.offlinePayModal.paymentDetails, pay =>{
              let {value, disabled, label, money} = pay;
              if (!disabled) paymentDetails.push({
                type: value,
                typeName: label,
                money
              })
            })
          }
          content = {
            fromTypeNote,
            storeId,
            userId,
            longitude,
            latitude,
            menuId,
            type,
            selfGetTime,
            payType,
            paymentDetails,
            name,
            vipPhone,
            phone,
            countryCode,
            address,
            isInvoice,
            invoiceType,
            invoiceDesc,
            taxNo,
            userNote,
            cardCode,
            pres,
            products,
            manualPreferentials,
            randomCode,
            isNeedTableware,
            cupListeningSet,
            actualOrderChannelType,
            storeNoteContent
          };
        }

        if(!this.isJYJForXL) {
          delete content.vipPhone
        }
        if (!isColaCupConversionListeningSet) {
          delete  content.cupListeningSet
        }
        if (orderType === 1 || orderType === 3) {
          delete content.selfGetTime;
        }
        this.submitLoading = true;
        this.server
          .get({
            name: urlName,
            data: {
              ...content,
              webFee: this.fee,
              webErrorList: window.errorList, //  前端报错信息
              isIntercept: true
            }
          })
          .then(res => {
            let msg = res.msg,
              status = res.status,
              data = res.data;
            if (status === 5 && data && data.length) {
              let list = [];
              // 餐品判断各种条件
              each(data, ({name, isInServiceTime, num, stock, isSoldOut}) => {
                let text = '餐品:' + name;
                if (!isInServiceTime) {
                  text += '不在营业时间'
                } else if (isSoldOut) {
                  text += '已售罄'
                } else if (num > stock) {
                  text += `最多选择${stock}份,您已选择了${num}份`
                }
                list.push(text)
              });
              msg += ',' + list.join(',');
            }
            this.$Modal.error({
              title: '提示',
              content: msg
            });
            if (status === 1) {
              if (!isAmend) {
                this.clearOrder();
              } else {
                this.$store.commit('booking/user/update', {
                  orderAmend: {
                    orderData: {},
                    isStore: false,
                    isAmend: false, // 是否可以改单
                    isProducts: false, // 是否可以更改餐品
                    isOnlinePay: false, // 是否是线上支付
                    isBase: false, // 是否可以更改基础信息（姓名、 电话、 备注、送餐地址）
                  }
                });
              }
              this.orderVisible = false;
              this.$nextTick(() => {
                this.$router.replace({
                  name: 'orderList'
                })
              })
            }
          }).finally(() => {
          this.submitLoading = false
        })
      },
      clearOrder() {
        // 清除数据
        let list = this.store.businessType,
          sendType = list.length ? list[0] : 1;
        each(initData, (value, key) => {
          this[key] = value
        });
        this.$store.dispatch('booking/user/update', {
          sendType
        });
        this.$emit('update', 'clear');
      },
      throttle: throttle(),
      updateTaste(taste) {
        //更新用户嗜好
        let oldTaste = this.oldTaste;
        if ((taste.trim() || oldTaste) && oldTaste !== taste) {
          this.throttle({
            callback(taste) {
              let {user} = this;
              this.server.get({
                name: 'updateTaste',
                data: {
                  taste,
                  phone: user.phone
                }
              }).then(() => {
                this.oldTaste = taste
              })
            },
            delay: 800,
            arg: [taste]
          })
        }
      }
    },
    components: {
      Card,
      Input,
      CcSelect,
      Button,
      Radio,
      RadioGroup,
      Modal,
      CheckboxGroup,
      Checkbox
      // Date
    },
    destroyed() {
    }
  }
</script>

<style scoped lang="less">
  .w150 {
    width: 150px;
  }
  .w-u-4 {
    width: 33%;
  }

  .order {
    color: #666;
    font-size: 14px;
    .order-pane-title {
      text-align: center;
      padding: 8px 0;
      font-size: 14px;
      background-color: #d4d5d5;
    }
    .order-cart-title {
      font-weight: 700;
    }
    .order-cart-item {
      word-break: break-all;
      font-weight: 400;
    }
    .order-delivery {
      font-size: 1.25em;
      font-weight: 700;
    }
    .order-text-orange {
      color: #f47e5a;
    }
    .order-total {
      font-weight: 700;
    }
  }

  .order-amend-hint {
    color: #999;
  }
  .cd-select-wrapper {
    vertical-align: middle;
  }
  .offline {
    &-pay {
      font-size:14px;
      &-hint {
        color: #999;
      }
      &-header {
        background-color:#D4D5D5;
        font-size:14px;
        font-weight: bold;
        padding: 13px 0;
      }
      &-form {
        border: 1px solid #D9DCDF;
        border-top:none;
        width:100%;
        &-group {
          width: 100%;
        }
      }
    }
  }
  .tip {
    color: #999;
    line-height: 1;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// components/pages/order/MoreInfo/MoreInfo.vue